import React from "react";
import ContentManagement from "../ContentManagement/ContentManagement";
import podcastManagementService from "../../services/PodcastManagementService";
import { CONTENT_TYPES_CONFIG } from "../../config/App.config";

const Podcast = () => {
  return (
    <ContentManagement
      service={podcastManagementService}
      pageSize={10}
      sidebarItemLayout="horizontal"
      // Reads detail from session via getEntity(); shows detail mode if present
      // use the podcast title as the slug
      getSlug="title"
      contentType={CONTENT_TYPES_CONFIG.PODCAST}
    />
  );
};

export default Podcast;